import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppConstants } from '../../app.constants';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import moment from 'moment-timezone';
import * as fromRoot from '../../reducers';
import { VersionService } from '@spotlight/shared/version';

@Component({
  selector: 'spot-footer',
  templateUrl: './spot-footer.component.html',
  styleUrls: ['./spot-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpotFooterComponent implements OnInit, OnDestroy {
  public versionNumber: string;
  public isMobile$: Observable<boolean>;
  public isAdminUser$: Observable<boolean>;
  public url: string = AppConstants.feedbackUrl;
  public currentYear = moment().format('YYYY');
  public showFooter: boolean;
  public isBlueBackground: boolean = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private versionService: VersionService
  ) {
    this.versionNumber = this.versionService.getVersion();
    this.isMobile$ = this.store.select(fromRoot.getIsMobile);
    this.isAdminUser$ = this.store.select(fromRoot.isAdminUser);
  }

  public ngOnInit(): void {

    this.updateFooterState();
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    )
      .subscribe(() => this.updateFooterState());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateFooterState(): void {
    // root -> :locationNumber (or a non-location gate like eula/maintenance) -> feature -> feature's own leaf route
    const childRoute = this.activatedRoute.root.firstChild?.firstChild?.firstChild;
    const routeData: { [x: string]: any; hideNavFooter?: any; isBlueBackground?: any; } | undefined = childRoute?.snapshot.data;
    this.showFooter = routeData ? !routeData.hideNavFooter : true;
    this.isBlueBackground = routeData ? routeData.isBlueBackground : false;
  }

  public goToFeedback() {
    window.open(this.url);
  }
}
